<template>
  <svg
    ref="icon"
    :viewBox="this.icon.viewBox"
    :class="classes ? classes : 'icon'"
  >
    <use :xlink:href="'#' + this.icon.id" />
  </svg>
</template>
<script>
export default {
  name: 'CSSVGIcon',
  props: {
    classes: {
      type: [String, Array],
      default: '',
      required: false,
    },
    guessSize: {
      type: Boolean,
      default: false,
      required: false,
    },
    iconName: {
      type: String,
      required: true,
    },
  },
  computed: {
    /**
     * TODO: use an import instead  (this would be async and thus requires
     * a few modifications to the rest of the code)
     * const icon = import(/* webpackMode: "eager" * / `@/assets/svg-icons/${
     *    this.iconName
     *  }.svg`)
     */
    icon() {
      // eslint-disable-next-line import/no-dynamic-require, global-require
      const icon = require(`@/assets/svg-icons/${this.iconName}.svg`)

      return icon.default
    },
  },
  mounted() {
    if (this.guessSize) {
      const viewBoxArray = this.icon.viewBox.split(' ')
      this.$refs.icon.style.width = `${viewBoxArray[2]}px`
      this.$refs.icon.style.height = `${viewBoxArray[3]}px`
    }
  },
}
</script>
